export { AboutMeCard as default } from './AboutMeCard';
